import { Auth, API } from "aws-amplify";
import { ThunkAction, ThunkDispatch } from "redux-thunk";

export enum Type {
  GOT_CUSTOM_SCHEMA = "GOT_CUSTOM_SCHEMA",
}

export interface IGotCustomSchema {
  type: Type.GOT_CUSTOM_SCHEMA;
  customSchema: any;
}

export type Action = IGotCustomSchema;

const getCustomSchema = async (): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  const response: any = await API.get("skytrains", "/getCustomSchema", {
    headers: { Accept: "*/*", Authorization: token },
  });
  return response;
};

// Example Schema 6.0
// const airportSchema = {
//   $id: "customAirportFields",
//   $schema: "http://json-schema.org/draft-07/schema",
//   title: "The Root Schema",
//   type: "object",
//   required: ["testIntegerField"],
//   properties: {
//     testIntegerField: {
//       type: "integer",
//       title: "Test Integer",
//       description: "Test Integer Field.",
//       minimum: 0,
//       maximum: 15,
//     },
//     testStringField: {
//       type: "string",
//       title: "Test String",
//       description: "Test String Field",
//       default: "hello",
//     },
//   },
// };

/**
 * Retrieves and stores customer custom schemas
 * @returns void - dispatch customer custom schema.
 */
export const getCustomerCustomPages = (): ThunkAction<Promise<string>, object, object, IGotCustomSchema> => {
  return async (dispatch: ThunkDispatch<object, object, any>, getState: any): Promise<any> => {
    const customSchema: any = await getCustomSchema();
    // const test = { ...customSchema, airport: JSON.stringify(airportSchema) };

    if (customSchema?._id) {
      dispatch({ type: Type.GOT_CUSTOM_SCHEMA, customSchema });
    }
  };
};
